import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { useSettings } from "@/contexts/SettingsContext";
import CartDrawer from "@/components/CartDrawer";

export default function Header() {
  const { items } = useCart();
  const { payments_enabled } = useSettings();
  const [cartOpen, setCartOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const NavLinks = ({ onNavigate }) => (
    <>
      <Link
        to="/"
        onClick={onNavigate}
        data-testid="nav-home"
        className="label-eyebrow-muted hover:text-[#E25C46] transition-colors"
      >
        Home
      </Link>
      <Link
        to="/store"
        onClick={onNavigate}
        data-testid="nav-store"
        className="label-eyebrow-muted hover:text-[#E25C46] transition-colors"
      >
        Store
      </Link>
      <Link
        to="/about"
        onClick={onNavigate}
        data-testid="nav-about"
        className="label-eyebrow-muted hover:text-[#E25C46] transition-colors"
      >
        About
      </Link>
      <Link
        to="/contact"
        onClick={onNavigate}
        data-testid="nav-contact"
        className="label-eyebrow-muted hover:text-[#E25C46] transition-colors"
      >
        Contact
      </Link>
    </>
  );

  return (
    <>
      <header
        data-testid="site-header"
        className="sticky top-0 z-40 bg-[#F8F5F2]/90 backdrop-blur-xl border-b border-[#E5D8BD]/60"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="site-logo"
            className="font-serif text-xl md:text-2xl tracking-tight text-[#2D2926] leading-none"
          >
            <span className="italic font-light">Colleen Prosser</span>
            <span className="text-[#E25C46]"> Art</span>
          </Link>

          <nav className="hidden md:flex items-center gap-12">
            <NavLinks />
          </nav>

          <div className="flex items-center gap-3">
            {payments_enabled && (
              <button
                data-testid="cart-open-btn"
                onClick={() => setCartOpen(true)}
                className="relative p-2 hover:text-[#E25C46] transition-colors"
                aria-label="Open cart"
              >
                <ShoppingBag className="w-5 h-5" />
                {items.length > 0 && (
                  <span
                    data-testid="cart-count"
                    className="absolute -top-0.5 -right-0.5 bg-[#E25C46] text-[#F8F5F2] text-[10px] font-medium w-4 h-4 flex items-center justify-center rounded-full"
                  >
                    {items.length}
                  </span>
                )}
              </button>
            )}
            <button
              data-testid="mobile-menu-btn"
              className="md:hidden p-2"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-[#E5D8BD]/60 bg-[#F8F5F2]">
            <div className="px-6 py-6 flex flex-col gap-5">
              <NavLinks onNavigate={() => setMobileOpen(false)} />
            </div>
          </div>
        )}
      </header>

      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
}
